import { configureStore } from "@reduxjs/toolkit";

import dashboardReducer from "./dashboardSlice";
import billboardReducer from "./billboardSlice";
import plantReducer from "./plantSlice";
import trailerArrivalReducer from "./trailerArrivalSlice";
import inventoryReducer from "./inventorySlice";
import yardReducer from "./yardSlice";
import allocatedReducer from "./allocatedSlice";
import oldTimeMachine from "./oldTimeMachineSlice";
import heatmapReducer from "./heatmapSlice";
import navHeatmapReducer from "./navHeatmapSlice";
import newTimeMachineReducer from "./newTimeMachineSlice";

export const store = configureStore({
  reducer: {
    dashboard: dashboardReducer,
    billboard: billboardReducer,
    plant: plantReducer,
    trailerArrival: trailerArrivalReducer,
    inventory: inventoryReducer,
    oldTimeMachine: oldTimeMachine,
    heatmap: heatmapReducer,
    navHeatmap: navHeatmapReducer,
    newTimeMachine: newTimeMachineReducer,
    allocated: allocatedReducer,
    yard: yardReducer
  }
});
